import React from "react";
import PropTypes from "prop-types";
//Limitless imports

import { validateSignInForm } from "../../../utils/validators/SignInFormValidator";
import { useSignInContext } from "../../../hooks/sign-in/SignInContext";
const PasswordResetForm = ({
  children,
  onVerificationCodeSent
}) => {
  const {
    email,
    setEmail,
    loading,
    forgotPassword,
    passwordResetError,
    clearErrors
  } = useSignInContext();
  const onFormSubmit = () => {
    forgotPassword(onVerificationCodeSent);
  };
  const handleChangeUserEmail = value => {
    setEmail({
      value,
      pristine: false
    });
  };
  const {
    fieldErrors,
    isFormInvalid,
    userErrorMessage
  } = validateSignInForm({
    email
  }, passwordResetError, "", false);
  return children({
    email,
    fieldErrors,
    isFormInvalid,
    userErrorMessage,
    onEmailChange: handleChangeUserEmail,
    onFormSubmit,
    clearAuthError: clearErrors,
    loading
  });
};
export default PasswordResetForm;
PasswordResetForm.propTypes = {
  children: PropTypes.func.isRequired,
  onVerificationCodeSent: PropTypes.func.isRequired
};